import { ActionCreatorWithPayload, createAction } from "@reduxjs/toolkit";
import { nps } from "lobbie";

export const setNpsSelfSignupInfo = createAction<Partial<nps.INPSSelfSignupInfo> | undefined>(
    "nps_self_signup_info/set",
) as ActionCreatorWithPayload<Partial<nps.INPSSelfSignupInfo> | undefined>;
